import { z } from "zod"
import { mbToBytes } from "@/lib/mb-to-bytes"
import { UPLOAD_CONFIGS } from "@/modules/upload/constants/upload-configs"
import { MedicalReportTypeValues } from "@/types/__generated__/union-types"

interface ExtendedFile extends File {
  preview?: string
}

const UploadSchema = z
  .object({
    documentType: z.enum(MedicalReportTypeValues).default("MEDICAL_REPORT"),
    files: z
      .array(
        z.custom<ExtendedFile>((file) => file instanceof File, {
          message: "patient.uploadFiles.expectAFile",
        }),
      )
      .min(UPLOAD_CONFIGS.MIN_FILE, {
        message: "patient.uploadFiles.addAtLeastOneFile",
      })
      .max(UPLOAD_CONFIGS.MAX_FILE),
  })
  .superRefine(({ files }, ctx) => {
    if (files.some((file) => file.size > mbToBytes(UPLOAD_CONFIGS.MAX_FILE_SIZE_IN_MB))) {
      ctx.addIssue({
        path: ["files"],
        message: "patient.uploadFiles.incompatibleFile",
        code: "custom",
      })
    }
  })

type UploadFormData = z.infer<typeof UploadSchema>
type UploadFormInput = z.input<typeof UploadSchema>

export { UploadSchema, type UploadFormData, type UploadFormInput }
